module.exports = __webpack_public_path__ + "static/media/diachi.c87e3af3.png";